/**
 * Constants for the Google Sheets Expense Service.
 */

/** localStorage key used to persist the Google Drive/Sheets ID cache. */
export const CACHE_KEY = 'growboard_google_sheets_cache';

/** Full list of calendar month names, ordered January–December. */
export const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const;
